import { createContext, useContext, useState, useEffect } from "react";

const SalonContext = createContext();

export const SalonProvider = ({ children }) => {
    const [salonUuid, setSalonUuid] = useState(null);
    const [salonName, setSalonName] = useState(null);
    const [membershipCount, setMembershipCount] = useState(0);

    // 🔑 user session state
    const [customerId, setCustomerId] = useState(null);
    const [customerName, setCustomerName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [accessToken, setAccessToken] = useState("");

    // 🔹 convenience method to set both uuid & name
    const setSalonDetails = ({ salonUuid, salonName }) => {
        if (!salonUuid) return;
        setSalonUuid(salonUuid);
        setSalonName(salonName || "");
        localStorage.setItem("SALON_UUID", salonUuid);
        if (salonName) localStorage.setItem("SALON_NAME", salonName);
    };

    useEffect(() => {
        // Load from localStorage when app starts
        const storedCustomerId = localStorage.getItem("CUSTOMER_ID");
        const storedName = localStorage.getItem("CUSTOMER_NAME");
        const storedMobile = localStorage.getItem("MOBILE_NUMBER");
        const storedToken = localStorage.getItem("ACCESS_TOKEN");

        const storedSalonUuid = localStorage.getItem("SALON_UUID");
        const storedSalonName = localStorage.getItem("SALON_NAME");

        if (storedCustomerId) setCustomerId(storedCustomerId);
        if (storedName) setCustomerName(storedName?.split(" ")[0] || "");
        if (storedMobile) setMobileNumber(storedMobile);
        if (storedToken) setAccessToken(storedToken);

        if (storedSalonUuid) setSalonUuid(storedSalonUuid);
        if (storedSalonName) setSalonName(storedSalonName);
    }, []);

    // 🔑 called on login success
    const login = (name, mobile, accessToken, customerId, refreshToken) => {
        localStorage.setItem("CUSTOMER_ID", customerId);
        localStorage.setItem("CUSTOMER_NAME", name);
        localStorage.setItem("MOBILE_NUMBER", mobile);
        localStorage.setItem("ACCESS_TOKEN", accessToken);
        localStorage.setItem("REFRESH_TOKEN", refreshToken);


        setCustomerId(customerId);
        setCustomerName(name?.split(" ")[0] || "");
        setMobileNumber(mobile);
        setAccessToken(accessToken);
    };

    // 🔑 called on logout
    const logout = () => {
        localStorage.removeItem("CUSTOMER_ID");
        localStorage.removeItem("CUSTOMER_NAME");
        localStorage.removeItem("MOBILE_NUMBER");
        localStorage.removeItem("ACCESS_TOKEN");
        //localStorage.removeItem("SALON_UUID");// Not removing this because this is the identifier for the salon
        localStorage.removeItem("SALON_NAME");

        setCustomerId(null);
        setCustomerName("");
        setMobileNumber("");
        setAccessToken("");

        setSalonUuid(null);
        setSalonName(null);
        setMembershipCount(0);
    };

    return (
        <SalonContext.Provider
            value={{
                salonUuid,
                setSalonUuid,
                salonName,
                setSalonName,
                setSalonDetails, // ✅ convenience
                customerId,
                customerName,
                mobileNumber,
                accessToken,
                login,
                logout,
                membershipCount,
                setMembershipCount,
            }}
        >
            {children}
        </SalonContext.Provider>
    );
};

export const useSalon = () => useContext(SalonContext);
